import { z } from 'zod';

export const formSchema = z.object({
  name: z.string().min(1, { message: 'Required' }),
  label: z.string().min(1, { message: 'Required' }),
  rate: z
    .string()
    .regex(/^\d*\.?\d*$/, { message: 'Must be a number' })
    .refine((val) => parseFloat(val) > 0, {
      message: 'Must be greater than 0'
    })
});
